import * as React from "react";
function useOnKeyboardEventOutside(ref, handler) {
  React.useEffect(() => {
    if (!handler || !document) {
      return;
    }
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("keyup", listener);
    return () => {
      document.removeEventListener("keyup", listener);
    };
  }, [!handler]);
}
export {
  useOnKeyboardEventOutside
};
//# sourceMappingURL=use-on-keyboard-outside.js.map
